var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNonClickableTripadvisor = function SvgNonClickableTripadvisor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.6 6)",
    fill: "#FF7A45",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.204 5.192a2.603 2.603 0 1 0-.006 5.207 2.603 2.603 0 0 0 .006-5.207Zm0 4.466a1.863 1.863 0 1 1 0-3.727 1.86 1.86 0 0 1 1.86 1.863 1.862 1.862 0 0 1-1.86 1.864Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.213,
    cy: 7.79,
    r: 1.295
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.597 5.192a2.602 2.602 0 1 0 0 5.205 2.602 2.602 0 0 0 0-5.205Zm0 4.466a1.863 1.863 0 1 1 0-3.727 1.86 1.86 0 0 1 1.86 1.863 1.862 1.862 0 0 1-1.86 1.864Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.605,
    cy: 7.79,
    r: 1.295
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.259 4.108 1.53-1.518h-3.101C15.95 1.177 13.064 0 10.388 0 7.71 0 4.849 1.177 3.11 2.59H0l1.53 1.518a5.205 5.205 0 0 0 7.117 7.587l1.762 1.296 1.741-1.267-.02-.049a5.205 5.205 0 0 0 8.667-3.885 5.205 5.205 0 0 0-1.538-3.682Zm-4.32-1.477a5.203 5.203 0 0 0-4.542 4.85 5.204 5.204 0 0 0-4.56-4.85c1.243-.893 2.826-1.332 4.552-1.332 1.725 0 3.308.439 4.55 1.332ZM5.204 11.7a3.904 3.904 0 1 1 0-7.81A3.907 3.907 0 0 1 9.11 7.793 3.91 3.91 0 0 1 5.204 11.7Zm10.393 0a3.907 3.907 0 0 1-3.905-3.906 3.907 3.907 0 0 1 3.905-3.905 3.907 3.907 0 0 1 3.905 3.905 3.91 3.91 0 0 1-3.905 3.906Z"
  }))));
};
export default SvgNonClickableTripadvisor;